import React from "react"

const SurveyScheduledReportExportContext = React.createContext(null)

export default SurveyScheduledReportExportContext
